import { render, staticRenderFns } from "./Prinzenpaare.vue?vue&type=template&id=0bd18361&scoped=true"
import script from "./Prinzenpaare.vue?vue&type=script&lang=js"
export * from "./Prinzenpaare.vue?vue&type=script&lang=js"
import style0 from "./Prinzenpaare.vue?vue&type=style&index=0&id=0bd18361&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd18361",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bd18361')) {
      api.createRecord('0bd18361', component.options)
    } else {
      api.reload('0bd18361', component.options)
    }
    module.hot.accept("./Prinzenpaare.vue?vue&type=template&id=0bd18361&scoped=true", function () {
      api.rerender('0bd18361', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Prinzenpaare.vue"
export default component.exports